(function ($) {
    "use strict";

    window.EnsembleVideo.User = (function () {
            var profile = {
                hapiUrl: $('#hapiUrl').val(),
                appUrl: $('#appUrl').val(),
                userId: $('#userId').val(),
                fileRegex: new RegExp("(.*?)\.(png|jpg|jpeg|gif)$"),
                imageUploadControlSelector: '.image-upload-control',
                userPhotoUrl: '#UserPhotoUrl',
                userPhoto: '#UserPhoto',
                pickPhotoButton: '#UserProfile_browsePhoto',
                deletePhotoButton: '#UserProfile_deletePhoto',
                photoBase64Data: '#UserProfile_photoBase64',
                cancelPhotoPreviewButton: '#UserProfile_cancelPhotoPreview',
                previewUploadPhotoContainer: '#previewUploadPhotoContainer',
                browseDeletePhotoContainer: '#browseDeletePhotoContainer',
                previewPhoto: '#UserProfile_previewPhoto',
                uploadPhotoButton: '#UserProfile_uploadPhoto',
                photoExtensionMessage: '#UserProfile_photoExtensionMessage',
                photoUploadErrorMessage: '#UserProfile_photoUploadErrorMessage',
                file: 'input[type="file"]',
                uploader: null,
                myCroppie: null,
                photoReader: null,
                fileName: null,
                handleDeletePhoto: function(e) {
                    var self = this;

                    $(self.userPhotoUrl).val('');
                    $(self.userPhoto).prop('src', '/app/images/ImagePlaceholder.jpg');
                    self.handleShowHideDeletePhotoButton();

                    e.preventDefault();
                },
                handleBrowsePhoto: function() {
                    $(this.photoBase64Data).trigger("click");
                },
                handleCancelPhotoPreview: function () {
                    $(this.previewUploadPhotoContainer).hide();
                    $(this.browseDeletePhotoContainer).show();
                },
                handleUploadPhoto: function () {
                    var self = this;

                    self.myCroppie.croppie('result', {
                        type: 'canvas',
                        size: 'viewport'
                    }).then(function (resp) {
                        jQuery.ajax({
                            cache: false,
                            type: "POST",
                            dataType: 'json',
                            contentType: "application/json; charset=utf-8",
                            headers: { 'Accept': "application/hal+json, application/json, */*; q=0.01" },
                            url: self.hapiUrl + 'v1/Users/' + self.userId + '/UploadPhotoBase64?UploadFromUI=true',
                            data: JSON.stringify({
                                PhotoBase64Data: resp.substring(resp.indexOf(',') + 1),
                                FileName: self.fileName
                            }),
                            success: function (response, status, xhr) {
                                $(self.userPhotoUrl).val(response.logoUrl);
                                $(self.userPhoto).prop('src', response.logoUrl);

                                $(self.previewUploadPhotoContainer).hide();
                                $(self.browseDeletePhotoContainer).show();

                                self.handleShowHideDeletePhotoButton();
                            },
                            error: function (request, status, error) {
                                $(self.photoUploadErrorMessage).show();
                                console.error(request.responseText);
                            }
                        });
                    });
                },
                handleValidateFileExtension: function(fileElement) {
                    var self = this;

                    var filePath = $(fileElement).val().toLowerCase();

                    if (!(self.fileRegex.test(filePath))) {
                        $(self.photoExtensionMessage).show();

                        return false;
                    }

                    $(self.photoExtensionMessage).hide();

                    return true;
                },
                handleFileLoad: function (e) {
                    var self = this;
                    self.destroyMyCroppie();

                    var fileElement = e.currentTarget;

                    if (!self.handleValidateFileExtension(fileElement)) return;

                    self.photoReader = new FileReader();
                    self.photoReader.onload = function (e) {
                        $(self.previewUploadPhotoContainer).show();
                        $(self.browseDeletePhotoContainer).hide();

                        self.myCroppie = $(self.previewPhoto).croppie({
                            viewport: {
                                width: 275,
                                height: 300
                            },
                            //boundary: { width: 525, height: 325 },
                            boundary: { height: 325 }
                        });
                        self.myCroppie.croppie('bind', {
                            url: e.target.result
                        });
                    };
                    // read the image file as a data URL.
                    self.photoReader.readAsDataURL(fileElement.files[0]);

                    // Set file name
                    self.fileName = e.target.files[0].name;

                    // Cleat file value so we can load the same file
                    e.target.value = '';
                },
                destroyMyCroppie: function () {
                    var self = this;

                    if (self.myCroppie !== null) {
                        self.myCroppie.croppie('destroy');
                    }
                },
                handleShowHideDeletePhotoButton: function() {
                    var self = this;

                    if ($(self.userPhoto).prop('src').indexOf("ImagePlaceholder.jpg") > -1) {
                        $(self.deletePhotoButton).hide();
                    } else {
                        $(self.deletePhotoButton).show();
                    }
                },
                init: function() {
                    var self = this;

                    self.handleShowHideDeletePhotoButton();

                    $(self.deletePhotoButton).on('click', $.proxy(self.handleDeletePhoto, this));
                    $(self.pickPhotoButton).on("click", $.proxy(self.handleBrowsePhoto, this));
                    $(self.cancelPhotoPreviewButton).on('click', $.proxy(self.handleCancelPhotoPreview, this));
                    $(self.uploadPhotoButton).on('click', $.proxy(self.handleUploadPhoto, this));
                    $(self.file).on('change', $.proxy(self.handleFileLoad, this));
                }
            },
            init = function () {
                profile.init();
            };

        return {
            Init: init,
            Profile: profile
        };
    })();

    $(window).ready(EnsembleVideo.User.Init);

}(jQuery));